import { useState, useEffect } from "react";
import SectionRegister from "./SectionRegister";
import Whatugetcomponent from "./Whatugetcomponent";
import AssessmentComparison from "./AssessmentComparison";
import ModelsQuestions from "./ModelsQuestions";
import { motion } from "framer-motion";
import Pricing from "./Pricing";
export default function Skillsphere() {
  // State for animated numbers
  const [schoolsCount, setSchoolsCount] = useState(0);
  const [studentsCount, setStudentsCount] = useState(0);
  const [workshopsCount, setWorkshopsCount] = useState(0);
  const [clientsCount, setClientsCount] = useState(0);
  const [showModels, setShowModels] = useState(false);
  // Target numbers
  const targetSchools = 25;
  const targetStudents = 5000;
  const targetWorkshops = 100;
  const targetClients = 200;
 
  useEffect(() => {
    // Animation duration in milliseconds
    const duration = 5000; // 2 seconds
    const startTime = performance.now();
 
    const animateCount = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1); // Clamp between 0 and 1
 
      // Calculate current values based on progress
      setSchoolsCount(Math.floor(progress * targetSchools));
      setStudentsCount(Math.floor(progress * targetStudents));
      setWorkshopsCount(Math.floor(progress * targetWorkshops));
      setClientsCount(Math.floor(progress * targetClients));
 
      // Continue animation until duration is complete
      if (progress < 1) {
        requestAnimationFrame(animateCount);
      }
    };
 
    // Start the animation
    requestAnimationFrame(animateCount);
  }, []);
 
 
  const fadeInAnimationVariants = {
    initial: { opacity: 0, y: 50 },
    animate: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.05 * index },
    }),
  };
 
  const handleClickHere = () => {
    setShowModels(true);
 
    setTimeout(() => {
      document.getElementById("models-questions")?.scrollIntoView({
        behavior: "smooth",
      });
    }, 100);
  };
 
 
 
  return (
    <div className="flex-col justify-center items-center">
      <section className="relative w-full h-auto pb-12 md:pb-20 overflow-hidden bg-white">
        {/* Background Blobs */}
        <div className="absolute inset-0 z-0">
          <div className="hidden md:block absolute bottom-[-150px] left-[-150px] w-[250px] sm:w-[350px] h-[200px] sm:h-[280px] bg-blue-400 rounded-full blur-3xl opacity-60"></div>
          <div className="absolute top-0 right-[-100px] w-[300px] sm:w-[400px] h-[300px] sm:h-[400px] bg-purple-300 rounded-full blur-3xl opacity-50"></div>
        </div>
 
        {/* Content Container */}
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-center md:mt-[100px] lg:mt-[80px] xl:mt-[65px]  px-4 sm:px-6 md:px-16 gap-6 md:gap-20 max-w-7xl mx-auto">
          {/* Text Content - Always centered on mobile */}
          <motion.div initial={{ opacity: 0, x: -100 }}
                      animate={{ opacity: 1, x: 0 }}
             transition={{ duration: 1 }}
                  whileInView="animate"
               className="text-center md:text-left w-full md:w-[55%] flex flex-col items-center md:items-start" >
            <h2
              className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold text-blue-600 mt-4 md:mt-0 flex flex-col xl:flex-row items-center xl:items-baseline"
              style={{ fontFamily: "Montserrat" }}
            >
              SKILLSPHERE{" "}
              <span
                className="bg-yellow-400 text-white px-3 py-1 rounded mt-2 xl:mt-0 xl:ml-2 w-fit"
                style={{ fontFamily: "Montserrat" }}
              >
                ASSESSMENT
              </span>
            </h2>
 
            <p
              className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-800 w-full md:w-[90%] leading-6 sm:leading-7 tracking-wide sm:tracking-widest"
              style={{ fontFamily: "Poppins" }}
            >
              A cutting-edge, science-backed assessment that provides students with 
              <span className="font-semibold ml-1" style={{ fontFamily: "Poppins" }}>
                Personalized Roadmap
              </span>{" "}
              for academic and professional growth.
            </p>
            <div
              className="mt-4 text-base sm:text-lg text-gray-800 w-full md:w-[90%] leading-6 sm:leading-7 tracking-wide sm:tracking-widest flex flex-col items-center md:items-start"
              style={{ fontFamily: "Poppins" }}
            >
              <button
                onClick={handleClickHere}
                className="bg-red-400 hover:bg-red-500 font-bold text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-md text-sm sm:text-base"
                style={{ fontFamily: "Poppins" }}
              >
                Click Here
              </button>
              <p
                className="mt-2 text-center md:text-left"
                style={{ fontFamily: "Poppins" }}
              >
                to explore research-based capability frameworks behind the assessment.
              </p>
            </div>
          </motion.div>
 
          {/* Image - Below content on mobile, to the right on md+ */}
          <motion.div   initial={{ opacity: 0, x: 100 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 1 }} whileInView="animate" className="w-full md:w-[45%] flex justify-center mt-4 md:mt-0">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/illustration.png'
              alt="Assessment Illustration"
              className="w-full max-w-md md:max-w-none"
            />
          </motion.div>
        </div>
      </section>
      {/* Stats Section (Below Main Section) */}
 
      <motion.div variants={fadeInAnimationVariants}  initial="initial"
        whileInView="animate"
        viewport={{ once: true }} className="relative w-full justify-center mt-[-60px] z-10 hidden md:flex">
        {/* Purple Glow (Only at Border) */}
        <div className="absolute inset-0 bg-purple-300 rounded-full blur-lg opacity-60 -z-10 mx-auto w-[calc(70%)] h-[calc(100%+20px)]"></div>
 
        {/* Main Card (White Background) */}
        <div className="relative bg-white rounded-full shadow-lg px-6 py-8 flex flex-wrap justify-around items-center gap-6 md:gap-0 w-[80vw] md:w-[70vw]">
          {/* Box 1 */}
          <div className="flex items-center">
            <img src='https://dbqa318yoj3nn.cloudfront.net/ribbonimage.png' alt="Schools" className="w-10 h-11 mb-2 mr-2" />
            <div className="flex flex-col">
              <p
                className="font-bold text-2xl"
                style={{ fontFamily: "Poppins" }}
              >
                {schoolsCount.toLocaleString()} +
              </p>
              <p
                className="text-sm w-[100px] font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                Schools Collaborated
              </p>
            </div>
          </div>
 
          {/* Box 2 */}
          <div className="flex items-center">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/graduate.png'
              alt="Students"
              className="w-10 h-11 mb-2 mr-2"
            />
            <div className="flex flex-col">
              <p
                className="font-bold text-2xl"
                style={{ fontFamily: "Poppins" }}
              >
                {studentsCount.toLocaleString()} +
              </p>
              <p
                className="text-sm w-[100px] font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                Students Enrolled
              </p>
            </div>
          </div>
 
          {/* Box 3 */}
          <div className="flex items-center">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/bluegirl.png'
              alt="Workshops"
              className="w-10 h-11 mb-2 mr-2"
            />
            <div className="flex flex-col">
              <p
                className="font-bold text-2xl"
                style={{ fontFamily: "Poppins" }}
              >
                {workshopsCount.toLocaleString()} +
              </p>
              <p
                className="text-sm w-[100px] font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                Workshops Organized
              </p>
            </div>
          </div>
 
          {/* Box 4 */}
          <div className="flex items-center">
            <img src='https://dbqa318yoj3nn.cloudfront.net/world.png' alt="Clients" className="w-10 h-11 mb-2 mr-2" />
            <div className="flex flex-col">
              <p
                className="font-bold text-2xl"
                style={{ fontFamily: "Poppins" }}
              >
                {clientsCount.toLocaleString()} +
              </p>
              <p
                className="text-sm w-[80px] font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                Happy Clients
              </p>
            </div>
          </div>
        </div>
      </motion.div>
 
      <div className="md:hidden grid grid-cols-2 gap-4 px-4 mt-4">
        {/* Card 1 */}
        <div className="relative h-40">
          {" "}
          {/* Fixed height */}
          <div className="absolute inset-0 bg-blue-300 rounded-xl blur-lg opacity-60 -z-10"></div>
          <div className="bg-white shadow-md rounded-xl flex flex-col items-center justify-center p-4 text-center border border-blue-100 relative z-10 h-full">
            {" "}
            {/* Added h-full */}
            <img src='https://dbqa318yoj3nn.cloudfront.net/ribbonimage.png' alt="Schools" className="w-8 h-8 mb-2" />{" "}
            {/* Slightly smaller icon */}
            <p
              className="text-xl font-bold text-black"
              style={{ fontFamily: "Poppins" }}
            >
              {" "}
              {/* Smaller text */}
              {schoolsCount.toLocaleString()} +
            </p>
            <p
              className="text-xs font-medium text-gray-700"
              style={{ fontFamily: "Poppins" }}
            >
              {" "}
              {/* Smaller text */}
              Schools Collaborated
            </p>
          </div>
        </div>
 
        {/* Card 2 */}
        <div className="relative h-40">
          <div className="absolute inset-0 bg-orange-300 rounded-xl blur-lg opacity-60 -z-10"></div>
          <div className="bg-white shadow-md rounded-xl flex flex-col items-center justify-center p-4 text-center border border-orange-100 relative z-10 h-full">
            <img src='https://dbqa318yoj3nn.cloudfront.net/graduate.png' alt="Students" className="w-8 h-8 mb-2" />
            <p
              className="text-xl font-bold text-black"
              style={{ fontFamily: "Poppins" }}
            >
              {studentsCount.toLocaleString()} +
            </p>
            <p
              className="text-xs font-medium text-gray-700"
              style={{ fontFamily: "Poppins" }}
            >
              Students Enrolled
            </p>
          </div>
        </div>
 
        {/* Card 3 */}
        <div className="relative h-40">
          <div className="absolute inset-0 bg-purple-400 rounded-xl blur-lg opacity-60 -z-10"></div>
          <div className="bg-white shadow-md rounded-xl flex flex-col items-center justify-center p-4 text-center border border-red-100 relative z-10 h-full">
            <img src='https://dbqa318yoj3nn.cloudfront.net/bluegirl.png' alt="Workshops" className="w-8 h-8 mb-2" />
            <p
              className="text-xl font-bold text-black"
              style={{ fontFamily: "Poppins" }}
            >
              {workshopsCount.toLocaleString()} +
            </p>
            <p
              className="text-xs font-medium text-gray-700"
              style={{ fontFamily: "Poppins" }}
            >
              Workshops Organized
            </p>
          </div>
        </div>
 
        {/* Card 4 */}
        <div className="relative h-40">
          <div className="absolute inset-0 bg-pink-400 rounded-xl blur-lg opacity-60 -z-10"></div>
          <div className="bg-white shadow-md rounded-xl flex flex-col items-center justify-center p-4 text-center border border-purple-100 relative z-10 h-full">
            <img src='https://dbqa318yoj3nn.cloudfront.net/world.png' alt="Clients" className="w-8 h-8 mb-2" />
            <p
              className="text-xl font-bold text-black"
              style={{ fontFamily: "Poppins" }}
            >
              {clientsCount.toLocaleString()} +
            </p>
            <p
              className="text-xs font-medium text-gray-700"
              style={{ fontFamily: "Poppins" }}
            >
              Happy Clients
            </p>
          </div>
        </div>
      </div>
 
      <div
        id="models-questions"
        className={`transition-all duration-500 overflow-hidden ${showModels ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"}`}
      >
        {showModels && <ModelsQuestions />}
      </div>
      <SectionRegister />
      <div className="overflow-x-hidden">
      <Whatugetcomponent />
      </div>
      <Pricing/>
      <AssessmentComparison />
    </div>
  );
}
 